import React, { Component } from 'react'
import dayjs from 'dayjs'

export default class DriverEventsBox extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { events } = this.props

        return (
            <div>
                {events.map((event, i) => {
                    return (<p key={i}>Gick in i enhet på <b>{event.lock.address.street}</b> - {dayjs(event.timestamp).format('HH:mm DD/MM')}</p>)
                })}
            </div>
        )
    }
}